import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  effect,
  computed
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DefaultMonacoLoader,
  NGX_MONACO_LOADER_PROVIDER,
  NgxMonacoEditorComponent,
} from '@jean-merelis/ngx-monaco-editor';
import { AiService } from '../../services/ai/ai.service';
import { FileSystemService } from '../../services/file-system.service';

const PLAIN_TEXT_EXTENSIONS = ['sas', 'log', 'lst'];

@Component({
  selector: 'editor',
  templateUrl: './editor.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxMonacoEditorComponent],
  providers: [
    {
      provide: NGX_MONACO_LOADER_PROVIDER,
      useFactory: () => new DefaultMonacoLoader(),
    },
  ],
})
export class EditorComponent {
  @Input() fileType: 'code' | 'md' | 'data' | 'image' | 'yaml' | 'json' | 'unknown' = 'unknown';
  
  // Use computed signal that reacts to fileType changes
  language = computed(() => {
    // return this.fileType === 'yaml' ? 'yaml' : 'r';
    if (this.fileType === 'yaml') return 'yaml';
    else if (this.fileType === 'json') return 'json';
    // Monaco has no SAS language; plain text beats mis-highlighting SAS as R.
    const ext = this.fs.visibleNode().path.split('.').pop()?.toLowerCase();
    return ext && PLAIN_TEXT_EXTENSIONS.includes(ext) ? 'plaintext' : 'r';
  });
  
  events: string[] = [];

  //this.fs.visibleNode().getContent().then((content) => content)
  // private contentSignal = computed<string>(() => {
  //   let newContent: string | null | undefined = null;
  //   this.fs
  //     .visibleNode()
  //     .getContent()
  //     .then((content) => (newContent = content));
  //   return newContent || '';
  // });
  content: string = '';
  constructor(private fs: FileSystemService, public aiService: AiService) {
    effect(async () => {
      try {
        const newContent = await this.fs.visibleNode().getContent();
        this.content = newContent ?? '';
      } catch (error) {
        console.error('Error loading file content:', error);
        this.content = '';
      }
    });
  }

  get fileName(): string {
    return this.fs.visibleNode().path.split('/').pop() || 'Untitled';
  }

  onContentChange(content: string) {
    // this.content = content;
    // this.contentChange.emit(this.content);
    this.fs.userContentChange(content);
  }

  // editorInitialized(editor: any) {
  //   this.events.push('editorInitialized');
  // }

  // onFocus() {
  //   this.events.push('focus');
  // }

  // onBlur() {
  //   this.events.push('blur');
  // }
}
